import { type AssignmentCosts, type AssignmentTeam } from './types'

const plannedGeolocation = (team: AssignmentTeam, costs: AssignmentCosts) => {
  const location = costs.details.teams[team._id]?.locationWhenAvailable
  if (typeof location === 'object' && 'notUsingGeolocation' in location) {
    return location.geolocation
  }
  return team.currentLocation?.geolocation ?? team.availableGeolocation
}

export const teamMapPositions = (teams: ReadonlyArray<AssignmentTeam>, costs: AssignmentCosts) =>
  Object.fromEntries(
    teams.flatMap((team) => {
      const geolocation = plannedGeolocation(team, costs)
      return geolocation ? [[team._id, { lat: geolocation.latitude, lng: geolocation.longitude }]] : []
    })
  )
